import { render } from "./remediation_types.vue?vue&type=template&id=53c2b250"
import script from "./remediation_types.vue?vue&type=script&lang=js"
export * from "./remediation_types.vue?vue&type=script&lang=js"

import exportComponent from "/home/deployer/asset-portal/releases/20260828153143/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__